import { render, staticRenderFns } from "./datasource-menu-process.vue?vue&type=template&id=a16b03a4&scoped=true&"
import script from "./datasource-menu-process.vue?vue&type=script&lang=ts&"
export * from "./datasource-menu-process.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16b03a4",
  null
  
)

export default component.exports